<div
  class="modal fade"
  [id]="modalMenuId"
  tabindex="-1"
  role="dialog"
  [attr.aria-labelledby]="modalMenuId"
  aria-hidden="true"
  >
  <div class="modal-dialog modal-dialog-drawer modal-dialog-drawer-right">
    <div class="modal-content">
      <div class="modal-header">
        @if (title) {
          <h3 class="modal-title">{{ title }}</h3>
        }
        <button type="button" class="modal-close-button" data-modal-dismiss="" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <ng-content select="[custom-links-top]"></ng-content>

        @for (linkGroup of linkGroups; track linkGroup) {
          @if (linkGroup.links?.length > 0) {
            <div class="row mb-5">
              <div class="column-12">
                @if (linkGroup.name) {
                  <h3>{{ linkGroup.name }}</h3>
                }
                <ul class="list-group-inset">
                  @for (link of linkGroup.links; track link) {
                    @if (link?.visible) {
                      <li class="is-clickable">
                        <!-- open sub menu -->
                        @if (!link.url) {
                          <div
                            class="flex align-items-center justify-content-between"
                            [attr.data-modal-toggle]="modalSubMenuRef">
                            <div>{{ link.text }}</div>
                            <a class="stretched-link">
                              <span class="icon-arrow-right"></span>
                            </a>
                          </div>
                        }
                        <!-- navigate to route -->
                        @if (link.url && link.url[0] === '/') {
                          <div
                            class="flex align-items-center justify-content-between"
                            data-modal-dismiss=""
                            (click)="closeParentModal()"
                            >
                            <div>{{ link.text }}</div>
                            <a class="stretched-link" [routerLink]="link.url" [appTrackingNav]="link.trackingLabel">
                              <span class="icon-arrow-right"></span>
                            </a>
                          </div>
                        }
                        @if (link.url && link.url[0] !== '/') {
                          <div class="flex align-items-center justify-content-between">
                            <!-- navigate to url -->
                            <div>{{ link.text }}</div>
                            <a class="stretched-link" [appTrackingNav]="link.trackingLabel" [href]="link.url">
                              <span class="icon-arrow-right"></span>
                            </a>
                          </div>
                        }
                      </li>
                    }
                  }
                </ul>
              </div>
            </div>
          }
        }

        <ng-content select="[custom-links-bottom]"></ng-content>
      </div>
    </div>
  </div>
</div>
